import type { MindstringPrototype } from "@/generated/fastapi";

type PrototypeColorPalette = "green" | "blue" | "orange" | "purple";

export type PrototypeThemeTokens = {
  accent: string;
  bg: string;
  border: string;
  colorPalette: PrototypeColorPalette;
};

export type PrototypeTone = {
  accent: string;
  accentBg: string;
  accentBorder: string;
  colorPalette: PrototypeColorPalette;
};

export const PROTOTYPE_THEME_TOKENS: Record<
  MindstringPrototype,
  PrototypeThemeTokens
> = {
  job_activity: {
    accent: "moveon.prototype.jobActivity.accent",
    bg: "moveon.prototype.jobActivity.bg",
    border: "moveon.prototype.jobActivity.border",
    colorPalette: "green",
  },
  learning_outcome: {
    accent: "moveon.prototype.learningOutcome.accent",
    bg: "moveon.prototype.learningOutcome.bg",
    border: "moveon.prototype.learningOutcome.border",
    colorPalette: "blue",
  },
  workplace_characteristic: {
    accent: "moveon.prototype.workplaceCharacteristic.accent",
    bg: "moveon.prototype.workplaceCharacteristic.bg",
    border: "moveon.prototype.workplaceCharacteristic.border",
    colorPalette: "orange",
  },
  individual_description: {
    accent: "moveon.prototype.individualDescription.accent",
    bg: "moveon.prototype.individualDescription.bg",
    border: "moveon.prototype.individualDescription.border",
    colorPalette: "purple",
  },
};

export const PROTOTYPE_TONES: Record<MindstringPrototype, PrototypeTone> = {
  job_activity: {
    accent: PROTOTYPE_THEME_TOKENS.job_activity.accent,
    accentBg: PROTOTYPE_THEME_TOKENS.job_activity.bg,
    accentBorder: PROTOTYPE_THEME_TOKENS.job_activity.border,
    colorPalette: PROTOTYPE_THEME_TOKENS.job_activity.colorPalette,
  },
  learning_outcome: {
    accent: PROTOTYPE_THEME_TOKENS.learning_outcome.accent,
    accentBg: PROTOTYPE_THEME_TOKENS.learning_outcome.bg,
    accentBorder: PROTOTYPE_THEME_TOKENS.learning_outcome.border,
    colorPalette: PROTOTYPE_THEME_TOKENS.learning_outcome.colorPalette,
  },
  workplace_characteristic: {
    accent: PROTOTYPE_THEME_TOKENS.workplace_characteristic.accent,
    accentBg: PROTOTYPE_THEME_TOKENS.workplace_characteristic.bg,
    accentBorder: PROTOTYPE_THEME_TOKENS.workplace_characteristic.border,
    colorPalette: PROTOTYPE_THEME_TOKENS.workplace_characteristic.colorPalette,
  },
  individual_description: {
    accent: PROTOTYPE_THEME_TOKENS.individual_description.accent,
    accentBg: PROTOTYPE_THEME_TOKENS.individual_description.bg,
    accentBorder: PROTOTYPE_THEME_TOKENS.individual_description.border,
    colorPalette: PROTOTYPE_THEME_TOKENS.individual_description.colorPalette,
  },
};

export function getPrototypeTone(prototype: MindstringPrototype) {
  return PROTOTYPE_TONES[prototype];
}

export function getPrototypeBadgeTokens(prototype: MindstringPrototype) {
  const tokens = PROTOTYPE_THEME_TOKENS[prototype];

  if (!tokens) {
    return {
      colorPalette: "gray" as const,
    };
  }

  return {
    bg: tokens.bg,
    borderColor: tokens.border,
    color: tokens.accent,
  };
}
